/**
 * TASK-156 — iPhone con la app instalada (PWA): al cerrar el teclado, iOS a veces deja la
 * página desplazada lo que ocupaba el teclado. Los elementos fijos quedan anclados ahí: la barra
 * inferior aparece a media pantalla y los modales de pantalla completa se cortan, dejando ver la
 * página de atrás. Al cerrarse el teclado se vuelve a la posición que había antes de abrirlo.
 */
const isEditable = (el) => Boolean(el) && (
    el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable
);

export const isIOS = (nav = typeof navigator !== 'undefined' ? navigator : null) => Boolean(nav) && (
    /iP(hone|ad|od)/.test(nav.userAgent || '') ||
    // iPadOS se presenta como Mac con pantalla táctil
    (nav.platform === 'MacIntel' && nav.maxTouchPoints > 1)
);

export const installIosViewportFix = (win = window) => {
    if (!isIOS(win.navigator)) return () => {};
    const doc = win.document;
    let keyboardOpen = false;
    let scrollBeforeKeyboard = 0;
    let timer = null;

    const onFocusIn = (e) => {
        if (!isEditable(e.target)) return;
        if (!keyboardOpen) scrollBeforeKeyboard = win.scrollY;
        keyboardOpen = true;
    };

    const onFocusOut = (e) => {
        if (!isEditable(e.target)) return;
        clearTimeout(timer);
        // Si el foco pasó a otro campo, el teclado sigue abierto
        timer = setTimeout(() => {
            if (isEditable(doc.activeElement)) return;
            keyboardOpen = false;
            const maxScroll = Math.max(0, doc.documentElement.scrollHeight - win.innerHeight);
            win.scrollTo(win.scrollX, Math.min(scrollBeforeKeyboard, maxScroll));
        }, 100);
    };

    doc.addEventListener('focusin', onFocusIn);
    doc.addEventListener('focusout', onFocusOut);
    return () => {
        clearTimeout(timer);
        doc.removeEventListener('focusin', onFocusIn);
        doc.removeEventListener('focusout', onFocusOut);
    };
};
